import { createContext, useContext } from 'react'

import type { useAccountApp } from './useAccountApp'

export type AccountAppContextValue = ReturnType<typeof useAccountApp>

export const AccountAppContext = createContext<AccountAppContextValue | null>(null)

export const useAccountAppContext = () => {
    const context = useContext(AccountAppContext)

    if (!context) {
        throw new Error('useAccountAppContext must be used within an AccountAppContext.Provider')
    }

    return context
}
